function loadHeroSearchModule () {
  console.log('adding user-clickable functionality to search bar');
  var showMissingSelectOptions = function (targetClassOrID) {
    return $(targetClassOrID).dropdown('toggle');
  };
  // when clicking on metro selection
  $('#js-search-location').on('mousedown', function (e) {
    analyticsIntegrations.homeSearchDropdown(true);
  });

  $('#js-search-location').change(function (e) {
    $('.js-searchbar-select-metro').removeClass('form-control error');
    var activeMetro = $('#js-search-location option:selected');
    var activeMetroText = activeMetro.text();
    $('#js-searchbar-metro-display-text').text(activeMetroText);
    if ('false' === activeMetro) {
      console.log('This option is not available');
      var landingPageUrl = activeMetro.attr('data-landing');
      if (landingPageUrl) {
        window.open(landingPageUrl, '_blank');
      }
      return;
    }
  });

  $('.js-searchbar-select-usetype').click(function (e) {
    analyticsIntegrations.homeSearchDropdown();
  });

  $('.searchbar-usetype-option').click(function (e) {
    $('.active.searchbar-usetype-option').removeClass('active');
    $(this).addClass('active');
    $('#js-searchbar-usetype-display-text').text($(this).attr('data-value'));
  });

  function open (elem) {
    if (document.createEvent) {
      var e = document.createEvent("MouseEvents");
      e.initMouseEvent("mousedown", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      elem[0].dispatchEvent(e);
    } else if (element.fireEvent) {
      elem[0].fireEvent("onmousedown");
    } else {
      return false;
    }
    return true;
  }

  $('#searchbar-submit-button').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    var metroSelection = $('#js-search-location option:selected');
    var usetypeSelection = $('.active.searchbar-usetype-option');
    if (!$('#js-search-location option:selected').val()) {
      $('.js-searchbar-select-metro').addClass('form-control error');
      open($('#js-search-location'));
    } else if (0 === usetypeSelection.length){
      showMissingSelectOptions('.js-searchbar-select-usetype');
    } else {
      var loccodeValue = metroSelection.attr('data-name')
      var createSearchLoc = loccodeValue.toLowerCase().replace(/ /g, '-');
      var usetypeValue = usetypeSelection.attr('data-value');
      var p1String = createSearchLoc + '/?space_use=' + usetypeValue;
      location.href = '/s/' + p1String;
    }
  });
  console.log('done adding search event listeners');
}
